// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  background-color: #222;
  color: #ccc;
  padding: 0;
  margin: 0;
}

.container {
  text-align: center;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
}

.title {
  font-size: 2.5rem;
}

/* game control buttons */
.start {
  grid-row: 2;
}

.start-button {
  background-color: maroon;
  color: white;
  font-size: 1.5rem;
  border: 1px solid black;
  border-radius: 10px;
  padding: 15px 45px;
  /* display: block; */
  margin: 0 auto 10px;
}

.play-again {
  grid-row: 1;
  grid-column: 2;
  justify-self: center;
  align-self: start;
}

.play-again-button {
  background-color: maroon;
  color: white;
  font-size: 1rem;
  white-space: nowrap;
  border: 1px solid black;
  border-radius: 10px;
  padding: 12px 25px;
  margin: 0 10px;
}

.start-button:hover,
.play-again-button:hover {
  filter: brightness(150%);
}

.instructions p {
  margin-top: 10px;
  font-size: 1.2rem;
}

/* game info display */
section {
  grid-row: 3;
}

.game-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: start;
  gap: 10px;
  width: 80vw;
}

.timer {
  justify-items: start;
  align-self: center;
  font-size: 1.4rem;
}

.question {
  justify-self: center;
  align-self: center;
  font-size: 1.4rem;
}

.score {
  justify-self: end;
  align-self: center;
  padding-right: 10px;
  font-size: 1.4rem;
  white-space: nowrap;
}

main {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
}

/* chessboard */
.chessboard {
  display: inline-grid;
  grid-template-columns: repeat(8, 10vw);
  grid-template-rows: repeat(8, 10vw);
  background-color: #470101;
  padding: 10px;
  width: 80vw;
}

.square {
  background-color: maroon;
  border: 1px solid black;
  cursor: pointer;
}

.darkSquare {
  background-color: maroon;
}

.lightSquare {
  background-color: antiquewhite;
}

/* option buttons */
.options {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

button.perspective,
button.type-button {
  width: 150px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid black;
  color: #111;
  margin: 10px;
  color: white;
  background-color: maroon;
  font-size: 1.25rem;
}

button.type-button {
  margin-top: 0;
}

.perspective:nth-child(odd) {
  background-color: antiquewhite;
  color: maroon;
}

.perspective:hover,
button.type-button:hover {
  filter: brightness(150%);
  border: 3px solid red;
}

/* color answer tiles */
.white-tile,
.black-tile {
  display: inline-grid;
  background-color: antiquewhite;
  border: 1px solid black;
  text-align: center;
  width: 100px;
  height: 100px;
  margin-bottom: 8px;
  margin-right: 10px;
  cursor: pointer;
}

.black-tile {
  background-color: maroon;
  justify-self: start;
  margin-right: 0px;
}

footer {
  text-align: center;
  padding: 20px;
}

footer a {
  text-decoration: none;
  color: #ccc;
}

footer a:hover {
  color: #fff;
}

/* utils */
.display-none {
  display: none;
}

.warning {
  color: red;
}

button.selected-type {
  border: 3px solid red;
}

button.selected {
  border: 3px solid red;
}

@media screen and (orientation: landscape) {
  .chessboard {
      grid-template-columns: repeat(8, 9vh);
      grid-template-rows: repeat(8, 9vh);
      width: 72vh;
    }

  .square:hover {
    filter: brightness(150%);
  }

  .game-info {
    width: 72vh;
  }

  .play-again-button,
  .timer,
  .question,
  .score {
    font-size: 2rem;
  }

  .white-tile:hover,
  .black-tile:hover {
    filter: brightness(150%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;;EAEE,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;MACI,qCAAqC;MACrC,kCAAkC;MAClC,WAAW;IACb;;EAEF;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":["body {\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-size: 14px;\r\n  background-color: #222;\r\n  color: #ccc;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.container {\r\n  text-align: center;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  justify-items: center;\r\n}\r\n\r\n.title {\r\n  font-size: 2.5rem;\r\n}\r\n\r\n/* game control buttons */\r\n.start {\r\n  grid-row: 2;\r\n}\r\n\r\n.start-button {\r\n  background-color: maroon;\r\n  color: white;\r\n  font-size: 1.5rem;\r\n  border: 1px solid black;\r\n  border-radius: 10px;\r\n  padding: 15px 45px;\r\n  /* display: block; */\r\n  margin: 0 auto 10px;\r\n}\r\n\r\n.play-again {\r\n  grid-row: 1;\r\n  grid-column: 2;\r\n  justify-self: center;\r\n  align-self: start;\r\n}\r\n\r\n.play-again-button {\r\n  background-color: maroon;\r\n  color: white;\r\n  font-size: 1rem;\r\n  white-space: nowrap;\r\n  border: 1px solid black;\r\n  border-radius: 10px;\r\n  padding: 12px 25px;\r\n  margin: 0 10px;\r\n}\r\n\r\n.start-button:hover,\r\n.play-again-button:hover {\r\n  filter: brightness(150%);\r\n}\r\n\r\n.instructions p {\r\n  margin-top: 10px;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* game info display */\r\nsection {\r\n  grid-row: 3;\r\n}\r\n\r\n.game-info {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  justify-items: start;\r\n  gap: 10px;\r\n  width: 80vw;\r\n}\r\n\r\n.timer {\r\n  justify-items: start;\r\n  align-self: center;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.question {\r\n  justify-self: center;\r\n  align-self: center;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.score {\r\n  justify-self: end;\r\n  align-self: center;\r\n  padding-right: 10px;\r\n  font-size: 1.4rem;\r\n  white-space: nowrap;\r\n}\r\n\r\nmain {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  justify-items: center;\r\n}\r\n\r\n/* chessboard */\r\n.chessboard {\r\n  display: inline-grid;\r\n  grid-template-columns: repeat(8, 10vw);\r\n  grid-template-rows: repeat(8, 10vw);\r\n  background-color: #470101;\r\n  padding: 10px;\r\n  width: 80vw;\r\n}\r\n\r\n.square {\r\n  background-color: maroon;\r\n  border: 1px solid black;\r\n  cursor: pointer;\r\n}\r\n\r\n.darkSquare {\r\n  background-color: maroon;\r\n}\r\n\r\n.lightSquare {\r\n  background-color: antiquewhite;\r\n}\r\n\r\n/* option buttons */\r\n.options {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 10px;\r\n}\r\n\r\nbutton.perspective,\r\nbutton.type-button {\r\n  width: 150px;\r\n  cursor: pointer;\r\n  padding: 6px 10px;\r\n  border-radius: 10px;\r\n  border: 1px solid black;\r\n  color: #111;\r\n  margin: 10px;\r\n  color: white;\r\n  background-color: maroon;\r\n  font-size: 1.25rem;\r\n}\r\n\r\nbutton.type-button {\r\n  margin-top: 0;\r\n}\r\n\r\n.perspective:nth-child(odd) {\r\n  background-color: antiquewhite;\r\n  color: maroon;\r\n}\r\n\r\n.perspective:hover,\r\nbutton.type-button:hover {\r\n  filter: brightness(150%);\r\n  border: 3px solid red;\r\n}\r\n\r\n/* color answer tiles */\r\n.white-tile,\r\n.black-tile {\r\n  display: inline-grid;\r\n  background-color: antiquewhite;\r\n  border: 1px solid black;\r\n  text-align: center;\r\n  width: 100px;\r\n  height: 100px;\r\n  margin-bottom: 8px;\r\n  margin-right: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.black-tile {\r\n  background-color: maroon;\r\n  justify-self: start;\r\n  margin-right: 0px;\r\n}\r\n\r\nfooter {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\nfooter a {\r\n  text-decoration: none;\r\n  color: #ccc;\r\n}\r\n\r\nfooter a:hover {\r\n  color: #fff;\r\n}\r\n\r\n/* utils */\r\n.display-none {\r\n  display: none;\r\n}\r\n\r\n.warning {\r\n  color: red;\r\n}\r\n\r\nbutton.selected-type {\r\n  border: 3px solid red;\r\n}\r\n\r\nbutton.selected {\r\n  border: 3px solid red;\r\n}\r\n\r\n@media screen and (orientation: landscape) {\r\n  .chessboard {\r\n      grid-template-columns: repeat(8, 9vh);\r\n      grid-template-rows: repeat(8, 9vh);\r\n      width: 72vh;\r\n    }\r\n\r\n  .square:hover {\r\n    filter: brightness(150%);\r\n  }\r\n\r\n  .game-info {\r\n    width: 72vh;\r\n  }\r\n\r\n  .play-again-button,\r\n  .timer,\r\n  .question,\r\n  .score {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .white-tile:hover,\r\n  .black-tile:hover {\r\n    filter: brightness(150%);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
